'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z' });

var CenterFocusStrong = function CenterFocusStrong(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CenterFocusStrong = (0, _pure2.default)(CenterFocusStrong);
CenterFocusStrong.muiName = 'SvgIcon';

exports.default = CenterFocusStrong;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CenterFocusStrong.js
// module id = 2237
// module chunks = 0